export default __webpack_public_path__ + "static/media/img-0325-botswana-full-face.92574883.png";